<template>
  <div class="page-wrapper">
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      loader="bars"
    ></loading>

    <ConfirmModal
      :msg="$t('download_report_msg')"
      :show="showConfirm"
      @close="showConfirm = false"
      @submit="doStart"
      :heading="$t('download_report')"
      :btnTxt="$t('yes_download')"
      is-yellow
    />

    <ConfirmModal
      :msg="$t('oops_download_msg')"
      :show="showOopsModal"
      :heading="$t('oops_download_heading')"
      :btnTxt="$t('ok')"
      @close="showOopsModal = false"
      @submit="showOopsModal = false"
      is-yellow
      :showSecondaryBtn="false"
    />

    <SuccessModal
      :show="showSuccessPopup"
      @close="closeSuccess"
      :msg="$t('download_file_msg', { email })"
      :heading="$t('download_file_heading')"
    />

    <UploadFile
      :show="showEditPopup"
      @close="showEditPopup = false"
      :heading="$t('upload_file')"
      :msg="$t('upload_file_txt')"
      :span="$t('span')"
      :action="$t('upload_file_action')"
      @isLoading="handleLoading"
      @showFileUploadSuccess="showFileUploadSuccess"
    />

    <success-modal
      :show="showSuccessPopupFile"
      @close="showSuccessPopupFile = false"
      :msg="'You have successfully added your file'"
      :heading="'File Added!'"
    />

    <div class="page-breadcrumb">
      <div class="row">
        <div
          class="col-md-5 col-lg-5 align-self-center col-12"
          style="margin-bottom: 0 !important"
        >
          <ul
            class="breadcrumb mb-2 list-style-none"
            style="padding: 0 !important; margin-top: 1rem"
          >
            <li class="h6 font-16 mylink" style="margin-right: 3rem">
              <router-link
                class="mylink text-capitalize"
                :to="'/export/dispatch'"
                >{{ $t("overview") }}</router-link
              >
            </li>
            <li class="h6 font-16 mylink" style="margin-right: 3rem">
              <router-link
                class="mylink text-capitalize"
                :to="'/export/dispatch/origin'"
                >{{ $t("origin") }}</router-link
              >
            </li>
            <li class="h6 font-16 mylink" style="margin-right: 3rem">
              <router-link
                class="mylink text-capitalize"
                :to="'/export/dispatch/destination'"
                >{{ $t("destination") }}</router-link
              >
            </li>
            <!-- <li class="h6 font-16 mylink" style="margin-right: 3rem">
              <router-link
                class="mylink text-capitalize"
                :to="'/export/dispatch/partners'"
                >{{ $t("partners") }}</router-link
              >
            </li> -->
          </ul>
        </div>

        <div
          class="col-md-7 col-lg-7 align-self-center col-12"
          style="display: flex; margin-left: auto; gap: 0.3rem"
        >
          <div v-if="showBreadcrumb" class="upload_container">
            <span class="upload_download" @click="showeditpopup">
              <img src="../../../assets/images/solar_upload-outline.svg" />
              <span> {{ $t("upload_file") }} </span>
            </span>
            <span class="upload_download" @click.prevent="downloadreport">
              <img src="../../../assets/images/solar_download-outline.svg" />
              <span> {{ $t("download_report") }} </span>
            </span>
          </div>
          <button class="btn d-block ml-auto btn-primary" @click="btnClicked">
            {{ btnLabel }}
          </button>
        </div>
      </div>
    </div>

    <router-view
      :showModal="showModal"
      :closeModal="closeModal"
      :handleShowModal="btnClicked"
      @download-success=""
    />

    <footer class="footer text-center">
      &#169;{{ new Date().getFullYear() }} {{ $t("all-rights") }}
    </footer>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import SuccessModal from "../../Modals/SuccessModal.vue";
import { mapActions, mapGetters } from "vuex";

import UploadFile from "../../Modals/UploadFile.vue";

import ConfirmModal from "../../../views/Modals/ConfirmModal.vue";

export default {
  name: "ExportDispatch",
  components: {
    Loading,
    UploadFile,
    ConfirmModal,
    SuccessModal,
  },
  computed: {
    ...mapGetters(["selectedId", "profile"]),

    btnLabel() {
      let label = "";
      switch (this.$route.name) {
        case "ExportDispatchOverview":
          return this.$t("add-shipment");
        case "ExportDispatchOrigin":
          return this.$t("add-origin");
        case "ExportDispatchDestination":
          return this.$t("add-destination");
        case "ExportDispatchPartners":
          return this.$t("add-partner");
        default:
          return label;
      }
    },
    showBreadcrumb() {
      const hideBreadcrumbPaths = [
        "/export/dispatch/origin",
        "/export/dispatch/destination",
      ];
      return !hideBreadcrumbPaths.some((path) => {
        return this.$route.path.startsWith(path);
      });
    },
    email() {
      console.log(this.profile.email);
      return this.profile?.email;
    },
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,
      showModal: false,
      showEditPopup: false,

      showConfirm: false,

      showOopsModal: false,

      showSuccessPopup: false,
      showSuccessPopupFile: false,
    };
  },
  methods: {
    ...mapActions(["downloadReport"]),
    showSuccess() {
      this.showSuccessPopup = true;
    },
    showeditpopup() {
      this.showEditPopup = true;
    },
    closeSuccess() {
      this.showSuccessPopup = false;
    },
    btnClicked() {
      this.showModal = !this.showModal;
    },
    closeModal() {
      this.showModal = false;
    },
    handleLoading(isLoading) {
      this.isLoading = isLoading;
    },
    showFileUploadSuccess() {
      this.showEditPopup = false;
      this.showSuccessPopupFile = true;
    },
    downloadreport() {
      if (!this.selectedId || this.selectedId.length === 0) {
        this.showOopsModal = true;
        this.showConfirm = false;
      } else this.showConfirm = true;
    },
    doStart() {
      this.isLoading = true;
      const downloadedReport = {
        shipmentIds: this.selectedId,
      };
      this.downloadReport(downloadedReport)
        .then((res) => {
          this.isLoading = false;
          this.showConfirm = false;

          this.showSuccessPopup = true;

          this.$emit("download-success");
        })
        .catch((error) => {
          console.error("Error downloaing file:", error);
          this.isLoading = false;
          this.Errormssg = "Error downloaing file. Please try again.";
        });
    },
  },
};
</script>

<style scoped>
.mylink {
  color: rgba(94, 106, 121, 1) !important;
  font-size: 14px !important;
  text-decoration-color: #213e7a !important;
}
.mylink :hover {
  color: #213e7a !important;
  text-decoration: underline;
  text-underline-offset: 5px;
  text-decoration-color: #213e7a !important;
}
.router-link-exact-active.router-link-active {
  text-decoration: underline !important;
  color: #213e7a !important;
  cursor: default;
  text-underline-offset: 5px;
}
.upload_container {
  display: flex;
}

.upload_download {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 14px;
  font-weight: 600;
  color: rgba(33, 62, 122, 1);
  /* margin-left: 6rem; */
  cursor: pointer;
}

@media (min-width: 827px) and (max-width: 898px) {
  .upload_container {
    margin-left: 3rem;
  }
}

@media (min-width: 899px) and (max-width: 934px) {
  .upload_container {
    margin-left: 5rem;
  }
}

@media (min-width: 932px) and (max-width: 991px) {
  .upload_container {
    gap: 6rem;
    margin-left: 8rem;
  }
}

@media (max-width: 1024px) {
  .upload_container {
    gap: 1.2rem;
  }

  .upload_download {
    margin-left: 0rem;
  }
}

@media (min-width: 1025px) and (max-width: 1084px) {
  .upload_container {
    gap: 1.2rem;
  }

  .upload_download {
    margin-left: 2rem;
  }
}

@media (min-width: 1084px) and (max-width: 1280px) {
  .upload_container {
    margin-left: 5rem;
    gap: 3rem;
  }

  .upload_download {
    margin-left: 0rem;
  }
}

@media (min-width: 1281px) and (max-width: 1399px) {
  .upload_download {
    margin-left: 0rem;
  }

  .upload_container {
    margin-left: 10rem;
    gap: 3rem;
  }
}

@media (min-width: 1400px) and (max-width: 1500px) {
  .upload_download {
    margin-left: 0rem;
  }

  .upload_container {
    margin-left: 13.5rem;
    gap: 3rem;
  }
}
</style>
